/* eslint-disable no-underscore-dangle */
import React, { useMemo, useState } from "react";
import { Button, Table } from "antd";
import { useForm, Controller } from "react-hook-form";
import { useParams, useHistory } from "react-router-dom";
import { CardElement, HomePageTable } from "../Common";

import { tableStringSorter } from "../../utils/table";
import { pmsBasedFileMappingCondition } from "../../utils/pms.utils";
import InputElement from "./ReportInputElement";
import CopyOverPMSReports from "./CopyOverPMSReports";
import { useGetReportListByPMS } from "../../hooks/pms.hooks";
import { DAILY } from "../../utils/report";
import { useGetProjectHotelPMS } from "../../hooks";

const tableHeight = window.innerHeight - 320;

const PMSReportsView = () => {
  const { hotelId, projectId, pmsId } = useParams();
  const history = useHistory();
  const [selectedPMSReports, setSelectedPMSReports] = useState("");
  const [copyPMSReports, setCopyPMSReports] = useState("");
  const [replicateModalOpen, setReplicateModalOpen] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    resetField,
    watch,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();

  const { data: pmsData } = useGetProjectHotelPMS(projectId);

  const { data: pmsReportsData, isLoading: pmsReportsLoading } =
    useGetReportListByPMS(pmsId);

  const copyOverSubmit = (data) => {
    const dataArray = Object.values(data);
    const uniqueScheduleTypes = new Set();

    const PMSName = pmsData?.find(
      (pmsProjects) => pmsProjects._id === pmsId,
    ).pms_name;
    const defaultFileMappingCondition = pmsBasedFileMappingCondition(PMSName);

    const rReportData = [];

    dataArray.forEach((row) => {
      rReportData.push({
        SourceType: row.source_type,
        business_date: "-1",
        signature_type: "1",
        report_name_matching_condition: defaultFileMappingCondition,
        ...row,
      });
      uniqueScheduleTypes.add(row.shedule_type);
    });

    setCopyPMSReports(rReportData);
    setReplicateModalOpen(true);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      const resetValues = {};

      setSelectedPMSReports(selectedRowKeys);
      selectedRows.forEach((row) => {
        resetValues[`${row._id}`] = {
          _id: row._id,
          report_name: row.report_name,
          mydocs_report_name: row.mydocs_report_name,
          mydocs_report_type:
            getValues(`${row._id}.mydocs_report_type`) ||
            row.mydocs_report_type,
          shedule_type: getValues(`${row._id}.shedule_type`) || DAILY,
          report_code: row.report_code,
          source_type: row.source_type,
          file_name: row.file_name,
        };
      });
      reset(resetValues);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const getTableColumns = () => {
    return [
      {
        title: "Report Name",
        dataIndex: "mydocs_report_name",
        fixed: "left",
        editable: false,
        width: "200px",
        sorter: tableStringSorter("mydocs_report_name"),
      },
      {
        title: "PMS Report Name",
        dataIndex: "report_name",
        width: "250px",
        editable: false,
        sorter: tableStringSorter("report_name"),
      },
      {
        title: "Report Code / Spooler Code",
        dataIndex: "report_code",
        width: "250px",
        editable: false,
        sorter: tableStringSorter("report_code"),
      },
      {
        title: "Report Frequency",
        dataIndex: "shedule_type",
        width: "200px",
        editable: true,
        render: () => <span>{DAILY}</span>,
      },
      {
        title: "Submission Type",
        dataIndex: "source_type",
        width: "200px",
        sorter: tableStringSorter("source_type"),
        editable: false,
      },
      {
        title: "myDocs Report Type",
        dataIndex: "mydocs_report_type",
        width: "200px",
        // sorter: tableStringSorter("report_type"),
        editable: true,
      },
      {
        title: "File Name",
        dataIndex: "file_name",
        width: "200px",
        sorter: tableStringSorter("file_name"),
        editable: false,
        // ...this.getColumnSearchProps("filenames", type),
      },
    ];
  };

  const mergedColumns = getTableColumns().map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: selectedPMSReports.includes(record._id),
      }),
    };
  });

  return (
    <CardElement
      title={`Standards Report -  ${
        pmsData
          ? pmsData?.find((pmsProjects) => pmsProjects._id === pmsId).pms_name
          : ""
      }`}
    >
      <HomePageTable>
        <form onSubmit={handleSubmit(copyOverSubmit)}>
          <Table
            rowSelection={{
              type: "checkbox",
              ...rowSelection,
            }}
            components={{
              body: {
                cell: (props) => {
                  const {
                    editing,
                    dataIndex,
                    record,
                    index,
                    children,
                    ...restProps
                  } = props;
                  return (
                    <td {...restProps}>
                      {editing ? (
                        <Controller
                          control={control}
                          name={`${record._id}.${dataIndex}`}
                          render={({ field }) => (
                            <InputElement
                              field={field}
                              resetField={resetField}
                              watch={watch}
                              setValue={setValue}
                              getValues={getValues}
                              reportCategories={[]}
                              errors={errors}
                              dataIndex={dataIndex}
                              formInputPath={`${record._id}.`}
                              documentTypes={[]}
                            />
                          )}
                        />
                      ) : (
                        children
                      )}
                    </td>
                  );
                },
              },
            }}
            columns={mergedColumns}
            dataSource={
              pmsReportsData?.filter((pmsReport) => pmsReport.status) ?? []
            }
            rowKey="_id"
            pagination={false}
            scroll={{ x: 800, y: tableHeight }}
            loading={pmsReportsLoading}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              disabled={!selectedPMSReports?.length}
              style={{ marginRight: "10px" }}
            >
              Copy Over
            </Button>
            <Button onClick={() => history.push("/report-management/view")}>
              Cancel
            </Button>
          </div>
        </form>
      </HomePageTable>
      <CopyOverPMSReports
        setOpen={setReplicateModalOpen}
        open={replicateModalOpen}
        dataSource={copyPMSReports}
        hotel={hotelId}
        project={projectId}
      />
    </CardElement>
  );
};

export default PMSReportsView;
